// 配信結果詳細画面の機能
window.deliveryResultsShow = function(prevResultUrl, nextResultUrl) {
  return {
    /**
     * 初期化処理
     */
    init() {
      this.setupDebugMemoSave();
      this.setupHtmlContentTabs();
      this.setupKeyboardShortcuts();
    },

    /**
     * デバッグメモ保存機能のセットアップ
     */
    setupDebugMemoSave() {
      const saveBtn = document.getElementById('save-memo-btn');
      const form = document.getElementById('debug-memo-form');

      if (saveBtn && form) {
        saveBtn.addEventListener('click', (e) => {
          e.preventDefault();

          // フォームの送信イベントを手動でトリガー
          const submitEvent = new Event('submit', {
            bubbles: true,
            cancelable: true
          });
          form.dispatchEvent(submitEvent);
        });

        // Turboフォーム送信後の処理
        form.addEventListener('turbo:submit-end', (event) => {
          const response = event.detail.fetchResponse;
          if (response && response.response.ok) {
            response.response.json().then(data => {
              if (data.success) {
                window.ToastNotifications.showSuccess(data.message);
              } else {
                window.ToastNotifications.showError('保存に失敗しました');
              }
            }).catch(() => {
              window.ToastNotifications.showError('レスポンスの解析に失敗しました');
            });
          } else {
            window.ToastNotifications.showError('エラーが発生しました');
          }
        });
      }
    },

    /**
     * HTMLコンテンツのタブ切り替え機能のセットアップ
     */
    setupHtmlContentTabs() {
      const tabButtons = document.querySelectorAll('[data-tab]');
      const previewContent = document.getElementById('content-preview');
      const sourceContent = document.getElementById('content-source');

      if (tabButtons.length > 0) {
        tabButtons.forEach(button => {
          button.addEventListener('click', function() {
            const tab = this.dataset.tab;

            // タブボタンのスタイル切り替え
            tabButtons.forEach(btn => {
              btn.className = 'py-2 px-1 border-b-2 border-transparent text-gray-500 hover:text-gray-700 font-medium text-sm';
            });
            this.className = 'py-2 px-1 border-b-2 border-blue-500 text-blue-600 font-medium text-sm';

            // コンテンツの表示切り替え
            if (tab === 'preview') {
              previewContent?.classList.remove('hidden');
              sourceContent?.classList.add('hidden');
            } else if (tab === 'source') {
              previewContent?.classList.add('hidden');
              sourceContent?.classList.remove('hidden');
            }
          });
        });
      }
    },

    /**
     * キーボードショートカットのセットアップ
     */
    setupKeyboardShortcuts() {
      document.addEventListener('keydown', (e) => {
        // input, textarea, select にフォーカスがある場合はショートカットを無効化
        const activeElement = document.activeElement;
        const tagName = activeElement?.tagName?.toLowerCase();
        if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
          return;
        }

        if (e.key === 'ArrowLeft' && prevResultUrl) {
          window.location.href = prevResultUrl;
        } else if (e.key === 'ArrowRight' && nextResultUrl) {
          window.location.href = nextResultUrl;
        }
      });
    }
  };
};